// استيراد hooks من React للتعامل مع الحالة والآثار الجانبية
import { useEffect, useState } from "react";
// استيراد Link للتنقل بين الصفحات بدون إعادة تحميل
import { Link } from "react-router-dom";
// استيراد حاوية Bootstrap لتنسيق المحتوى
import { Container } from "react-bootstrap";
// استيراد مكتبة الأيقونات FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد أيقونات الأسهم للتنقل بين الشرائح
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
// استيراد أيقونات وسائل التواصل الاجتماعي
import { faInstagram, faFacebookF, faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";
// استيراد Context الخاص باللغة لترجمة النصوص ومعرفة اتجاه الكتابة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف التنسيقات الخاصة بالمتجر
import "../../../Css/Storefront.css";

// تصدير المكون الرئيسي للصفحة الرئيسية (الهيرو)
export default function Landing ()
{
  // استدعاء دالة الترجمة واتجاه الكتابة من Context اللغة
  const { t, dir } = useLanguage();
  // حالة لتحديد الشريحة النشطة حالياً (تبدأ من 0)
  const [ activeIndex, setActiveIndex ] = useState( 0 );

  // مصفوفة الشرائح المعروضة في البانر الرئيسي
  const slides = [
    {
      key: "a", // مفتاح فريد للشريحة الأولى
      badge: t( 'hero.slide1Badge' ), // النص الموجود على الشارة الكبيرة
      leftLabel: t( 'hero.slide1LeftLabel' ), // النص الجانبي الأيسر
      eyebrow: t( 'hero.slide1Eyebrow' ), // النص العلوي الصغير (الحاجب)
      title: t( 'hero.slide1Title' ), // العنوان الرئيسي
      subtitle: t( 'hero.slide1Subtitle' ), // النص الفرعي
      image: "/hero-slide-2.jfif", // مسار الصورة
    },
    {
      key: "b", // مفتاح فريد للشريحة الثانية
      badge: t( 'hero.slide2Badge' ),
      leftLabel: t( 'hero.slide2LeftLabel' ),
      eyebrow: t( 'hero.slide2Eyebrow' ),
      title: t( 'hero.slide2Title' ),
      subtitle: t( 'hero.slide2Subtitle' ),
      image: "/hero-slide-1.jfif",
    },
  ];

  // تأثير جانبي للتبديل التلقائي بين الشرائح كل 5 ثوانٍ
  useEffect( () =>
  {
    // إنشاء مؤقت زمني يغير الشريحة النشطة كل 5 ثوانٍ
    const interval = setInterval( () =>
    {
      // زيادة رقم الشريحة مع العودة إلى 0 عند الوصول للآخر
      setActiveIndex( ( prev ) => ( prev + 1 ) % slides.length );
    }, 5000 ); // 5000 ميلي ثانية = 5 ثوانٍ

    // تنظيف المؤقت عند إزالة المكون لمنع تسرب الذاكرة
    return () => clearInterval( interval );
  }, [ slides.length ] ); // إعادة التشغيل فقط عند تغيير عدد الشرائح

  // دالة للانتقال إلى الشريحة السابقة
  const goPrev = () => setActiveIndex( ( prev ) => ( prev - 1 + slides.length ) % slides.length );

  // دالة للانتقال إلى الشريحة التالية
  const goNext = () => setActiveIndex( ( prev ) => ( prev + 1 ) % slides.length );

  // إرجاع واجهة المستخدم
  return (
    <Container> {/* حاوية Bootstrap لضبط العرض ومنع التمدد الزائد */ }
      <div className="hero-banner"> {/* الحاوية الرئيسية للبانر */ }

        {/* تكرار على مصفوفة الشرائح لعرض كل شريحة */ }
        { slides.map( ( slide, index ) => (
          <div
            key={ slide.key } // مفتاح فريد لكل عنصر
            // إضافة كلاس is-active إذا كانت هذه الشريحة هي النشطة حالياً
            className={ `hero-banner-slide ${ index === activeIndex ? "is-active" : "" }` }
          >
            {/* عناصر زخرفية (أشكال هندسية) لإضافة جمالية للتصميم */ }
            <span className="hero-banner-shape hero-banner-shape--1" />
            <span className="hero-banner-shape hero-banner-shape--2" />

            {/* أيقونات وسائل التواصل الاجتماعي - استبدل # بروابط صفحاتك الفعلية */ }
            <div className="hero-social-icons">
              <a href="https://www.facebook.com/saleem2020r/" aria-label="instagram"> {/* رابط إنستغرام */ }
                <FontAwesomeIcon icon={ faInstagram } />
              </a>
              <a href="https://www.facebook.com/saleem2020r/" aria-label="facebook"> {/* رابط فيسبوك */ }
                <FontAwesomeIcon icon={ faFacebookF } />
              </a>
              <a href="https://www.linkedin.com/in/saleem-farhan-6b3b2b282/" aria-label="linkdin"> {/* رابط تويتر */ }
                <FontAwesomeIcon icon={ faLinkedin } />
              </a>
            </div>

            {/* القسم الأيسر من الشريحة: يحتوي على التصنيف والشارة */ }
            <div className="hero-banner-left">
              <span className="hero-banner-left-label">{ slide.leftLabel }</span> {/* النص الجانبي */ }
              <span className="hero-banner-badge-big">{ slide.badge }</span> {/* الشارة الكبيرة */ }
            </div>

            {/* قسم الصورة: يحتوي على صورة الشريحة */ }
            <div className="hero-banner-photo-wrap">
              <img src={ slide.image } alt="" className="hero-banner-photo-img" /> {/* صورة المنتج/العرض */ }
            </div>

            {/* القسم الأيمن من الشريحة: يحتوي على النصوص والزر */ }
            <div className="hero-banner-right">
              <span className="hero-banner-eyebrow">{ slide.eyebrow }</span> {/* النص العلوي الصغير */ }
              <h1 className="hero-banner-title">{ slide.title }</h1> {/* العنوان الرئيسي */ }
              <p className="hero-banner-subtitle">{ slide.subtitle }</p> {/* النص الفرعي */ }
              <Link to="/" className="hero-banner-cta"> {/* زر الدعوة للشراء */ }
                { t( 'hero.cta' ) } {/* نص الزر مترجم */ }
              </Link>
            </div>
          </div>
        ) ) }

        {/* زر الانتقال إلى الشريحة السابقة */ }
        <button className="hero-nav-arrow hero-nav-arrow--prev" onClick={ goPrev } aria-label="previous slide">
          {/* تغيير اتجاه السهم بناءً على اتجاه اللغة (RTL/LTR) */ }
          <FontAwesomeIcon icon={ dir === 'rtl' ? faChevronRight : faChevronLeft } />
        </button>

        {/* زر الانتقال إلى الشريحة التالية */ }
        <button className="hero-nav-arrow hero-nav-arrow--next" onClick={ goNext } aria-label="next slide">
          {/* تغيير اتجاه السهم بناءً على اتجاه اللغة (RTL/LTR) */ }
          <FontAwesomeIcon icon={ dir === 'rtl' ? faChevronLeft : faChevronRight } />
        </button>

        {/* النقاط السفلية للتنقل بين الشرائح */ }
        <div className="hero-dots">
          { slides.map( ( slide, index ) => (
            <button
              key={ slide.key } // مفتاح فريد لكل نقطة
              // إضافة كلاس is-active إذا كانت النقطة تمثل الشريحة النشطة
              className={ `hero-dot ${ index === activeIndex ? "is-active" : "" }` }
              // عند النقر على النقطة، الانتقال إلى الشريحة المقابلة
              onClick={ () => setActiveIndex( index ) }
              aria-label={ `go to slide ${ index + 1 }` } // وصف تسمية توضيحي لإمكانية الوصول
            />
          ) ) }
        </div>
      </div>
    </Container>
  );
}